import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page24() {
  useEffect(() => {
    document.title = "Маяк — Страница 23"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page22" />
        <ForwardLink href="/page24" />
      </div>

      <p style={{ textAlign: "right" }}>23.</p>
      <p>ВНУТРИ. МАШИННОЕ ОТДЕЛЕНИЕ – ПОЗЖЕ</p>
      <p>
        МОЛОДОЙ все еще стоит, прижимая тряпку к меди, которую<br/>
        полирует.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        ?
      </p>
      <p>СТАРИК в ярости.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не отрицай этого.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Сэр?
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – ДЕНЬ</p>
      <p>
        СТАРИК стоит в камбузе, в ужасе показывая на пол. Пол<br/>
        выглядит как и всегда. Как он может выглядеть иначе?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Как ты это назовешь?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Сэр?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я мыл и подметал. Дважды,<br/>
        сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты – лживый пес.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я подметал их--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Они грязные.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Не протертые, немытые и в пятнах.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (себе под нос)<br/>
        Ты получаешь что-то вроде наслаждения,<br/>
        приставая ко мне?
      </p>
      <p style={{ textAlign: "right" }}>23.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page22" />
        <ForwardLink href="/page24" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710013595/the-lighthouse-script/yumc5jffsqfpx2oxdtac.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page24;
